import { useBootstrap } from '../context/BootstrapContext'

export function useCamps() {
  const { data, loading } = useBootstrap()
  return { camps: data.camps, loading }
}
